import React from 'react';
import { Icon, Separator } from '@zydalabs/storefront-components';
import useTranslation from 'next-translate/useTranslation';
import SwitchButton from '@zydalabs/storefront-components/lib/components/Switch';
import { Typography, useTheme } from '@zydalabs/zac-react';
import { usePersistedWalletUsed } from 'common/hooks';
import { IcGrayInfo, IcYellowWallet } from 'common/icons';
import { useLayout } from 'service/hooks';
import useWalletBalanceWithCurrency from 'modules/userModule/hooks/useWalletBalanceWithCurrency';
import { LANGUAGE_AR } from 'common/constants';
import { RenderingRegistry } from 'common/lib/registries';
import {
  WalletCardWrapper,
  WalletCardContent,
  WalletCardFirstRow,
  WalletCardBalance,
  WalletCardInfo,
  StyledFixedDirectionWrapper,
} from './style';

type WalletCardPropsType = {
  isOnlinePayment: boolean;
};
const WalletCard: React.FC<WalletCardPropsType> = ({ isOnlinePayment }) => {
  const { t, lang } = useTranslation('wallet');
  const { data: layoutSettings } = useLayout();
  const [isWalletUsed, setIsWalletUsed] = usePersistedWalletUsed();
  const walletBalanceWithCurrency = useWalletBalanceWithCurrency();
  const { colors } = useTheme();
  const isArabic = lang === LANGUAGE_AR;

  return (
    <WalletCardWrapper>
      <WalletCardFirstRow>
        <WalletCardContent>
          <Icon icon={IcYellowWallet} />
          <WalletCardBalance>
            <Typography variant="heading14" mb={4} color={colors.positive.primary}>
              {`${isArabic ? layoutSettings?.titleAr : layoutSettings?.titleEn} ${t('wallet').toLocaleLowerCase()}`}
            </Typography>
            <Typography variant="body14">{walletBalanceWithCurrency}</Typography>
          </WalletCardBalance>
        </WalletCardContent>
        <StyledFixedDirectionWrapper>
          <SwitchButton
            isChecked={isWalletUsed}
            isDisabled={!isOnlinePayment}
            onChange={() => {
              setIsWalletUsed(!isWalletUsed);
              RenderingRegistry.setIsWalletUsed(!isWalletUsed);
            }}
          />
        </StyledFixedDirectionWrapper>
      </WalletCardFirstRow>
      <Separator />
      <WalletCardInfo>
        <Icon icon={IcGrayInfo} />
        <Typography variant="body14" ml={8} color={colors.positive.secondary}>
          {`${isArabic ? layoutSettings?.titleAr : layoutSettings?.titleEn} ${t('walletInstructions')}`}
        </Typography>
      </WalletCardInfo>
    </WalletCardWrapper>
  );
};

export default WalletCard;
